var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.83333C0 1.26846 1.26855 0 2.83333 0H31.1667C32.7314 0 34 1.26846 34 2.83333V31.1667C34 32.7315 32.7314 34 31.1667 34H2.83333C1.26855 34 0 32.7315 0 31.1667V2.83333ZM17 15.5833C20.1297 15.5833 22.6667 13.0462 22.6667 9.91667C22.6667 6.7871 20.1297 4.25 17 4.25C13.8703 4.25 11.3333 6.7871 11.3333 9.91667C11.3333 13.0462 13.8703 15.5833 17 15.5833ZM28.3355 27.3357L28.3333 26.9167C28.3333 21.0487 22.868 17 17 17C11.132 17 5.66662 21.0487 5.66662 26.9167L5.66446 27.335C5.65992 28.0853 5.65115 29.5423 5.66667 29.75H28.3333C28.3489 29.5423 28.34 28.086 28.3355 27.3357Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.c1e122b2c74266d1341580dc27e31eb7.svg";
export { ForwardRef as ReactComponent };